import React from 'react';

const DonateShirt = () => {
  const url = 'https://secure.actblue.com/donate/supportren';
  
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
      {/* Modern Card Container */}
      <div className="relative bg-gradient-to-br from-white via-white to-gray-50 rounded-2xl border border-gray-100 shadow-xl overflow-hidden">
        {/* Decorative Elements - Hidden on mobile for better performance */}
        <div className="hidden sm:block absolute top-0 right-0 w-48 h-48 sm:w-64 sm:h-64 bg-gradient-to-bl from-[var(--primary)]/5 to-transparent rounded-full -translate-y-16 sm:-translate-y-32 translate-x-16 sm:translate-x-32 blur-3xl"></div>
        <div className="hidden sm:block absolute bottom-0 left-0 w-48 h-48 sm:w-64 sm:h-64 bg-gradient-to-tr from-[var(--primary)]/5 to-transparent rounded-full translate-y-16 sm:translate-y-32 -translate-x-16 sm:-translate-x-32 blur-3xl"></div>
        
        <div className="relative flex flex-col lg:flex-row items-stretch">
          {/* Premium Image Section */}
          <a 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="block lg:w-2/5 relative overflow-hidden group"
          >
            <div className="relative h-full min-h-[250px] sm:min-h-[300px] lg:min-h-[400px]">
              <img
                src="https://backend.ren4misenate.com/media/media_files/shirt.jpeg"
                alt="Thank you gift for donation"
                className="absolute inset-0 w-full h-full object-cover transition-all duration-700 group-hover:scale-110 group-hover:rotate-1"
              />
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
              {/* Shine Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
              
              {/* Gratitude Badge */}
              <div className="absolute top-4 left-4 sm:top-6 sm:left-6">
                <div className="flex items-center gap-2 bg-white/90 backdrop-blur-sm px-3 py-1.5 sm:px-4 sm:py-2 rounded-full shadow-lg">
                  <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-[var(--primary)] rounded-full animate-pulse"></div>
                  <span className="text-xs sm:text-sm font-semibold text-gray-800">Our Thank You Gift</span>
                </div>
              </div>
            </div>
          </a>

          {/* Premium Content Section */}
          <div className="lg:w-3/5 p-5 sm:p-8 lg:p-12 bg-gradient-to-b from-white to-gray-50/50">
            {/* Header */}
            <div className="mb-6 sm:mb-8">
              <div className="inline-flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                <div className="w-8 h-1 sm:w-12 sm:h-1 bg-gradient-to-r from-[var(--primary)] to-[var(--primary-hover)] rounded-full"></div>
                <span className="text-xs sm:text-sm font-semibold tracking-wider text-[var(--primary)] uppercase">
                  Support the Campaign
                </span>
              </div>
              
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                Donate & Receive <br className="hidden sm:block" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[var(--primary)] to-[var(--primary-hover)]">
                  Our Special Thank You Gift
                </span>
              </h3>
              
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                Make a donation to support Ren's campaign for positive change in our community, 
                and receive this exclusive campaign shirt as our heartfelt thank you. Your 
                contribution directly supports our mission, and the shirt is our way of showing 
                our gratitude for your support.
              </p>
            </div>

            {/* CTA Section */}
            <div className="flex flex-col sm:flex-row items-center justify-between gap-6 pt-6 border-t border-gray-100">
              <div className="flex items-center gap-2 sm:gap-3 order-2 sm:order-1">
                <div className="flex-shrink-0">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-xs sm:text-sm text-gray-600">SSL Secured • Powered by ActBlue</span>
              </div>
              
              <a 
                href={url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="group relative inline-flex items-center justify-center gap-2 sm:gap-3 bg-gradient-to-r from-[var(--primary)] to-[var(--primary-hover)] text-white font-semibold text-base sm:text-lg px-6 sm:px-10 py-3 sm:py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 w-full sm:w-auto order-1 sm:order-2 whitespace-nowrap"
              >
                <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-white/0 via-white/10 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="relative">Make a Donation</span>
                <svg className="w-4 h-4 sm:w-5 sm:h-5 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonateShirt;